export default __webpack_public_path__ + "static/media/home3.43f85891.webp";